// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Redirect, Route, Switch } from 'react-router-dom';
import Helmet from 'react-helmet';
import * as friendsActions from 'app/actions/friendsActions';
import * as groupActions from 'app/actions/groupActions';
import Responsive from 'app/components/responsive/Responsive';
import Page from 'app/containers/parts/Page';
import FriendFullScreenSlider from 'app/components/friends/FriendFullScreenSlider';
import FriendsGroupMain from 'app/scenes/friends/FriendsGroupMain';
import UserOnly from 'app/components/util/UserOnly';
import t from 'app/utils/translate';
import NotificationHandler from 'app/components/notifications/NotificationHandler';

type Props = {
  errorMessage?: string,
  fetchFriends: () => void,
  fetchGroups: () => void,
  friendOnShow?: Friend | FriendRequest,
  infoMessage?: string,
};

class Friends extends Component<Props> {
  props: Props;

  static defaultProps = {
    errorMessage: '',
    infoMessage: '',
    friendOnShow: undefined,
  };

  componentDidMount() {
    const { fetchFriends, fetchGroups } = this.props;

    fetchFriends();
    fetchGroups();
  }

  render() {
    const {
      errorMessage,
      friendOnShow,
      infoMessage,
    } = this.props;

    return (
      <UserOnly>
        <NotificationHandler
          type="warning"
          afterCond={!!errorMessage}
          beforeCond={!errorMessage}
        >
          {errorMessage}
        </NotificationHandler>
        <NotificationHandler
          type="info"
          afterCond={!!infoMessage}
          beforeCond={!infoMessage}
        >
          {infoMessage}
        </NotificationHandler>
        <Page title={t('Friends')}>
          <Helmet title={t('Friends')} />
          <Switch>
            <Route path="/groups/:group_id" component={FriendsGroupMain} />
            <Redirect from="/groups" to="/groups/friends" />
          </Switch>
          <Responsive mobile tabletPortrait={false}>
            <FriendFullScreenSlider friend={friendOnShow} showOnMobile />
          </Responsive>
        </Page>
      </UserOnly>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  const getError = errors => get(errors, 'message') || get(errors, 'messages[0].message');

  return {
    errorMessage: getError(state.friends.errors) || getError(state.friendGroups.errors),
    infoMessage: state.friendGroups.infoMessage,
    friendOnShow: state.friends.currentFriend,
  };
}

const actions = {
  fetchFriends: friendsActions.fetchFriends,
  fetchGroups: groupActions.fetchGroupsWithMembers,
};

const connector = connect(mapStateToProps, actions);

export default connector(Friends);
